import { createPortal } from "react-dom";
import { Fragment, useEffect } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import "./Modal.css";

const Modal = ({ closeModal, modalName, children }) => {
  useEffect(() => {
    document.body.classList.add("overflow-hidden");
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, []);
  return createPortal(
    <Fragment>
      <div className="modal-overlay" onClick={closeModal}></div>
      <div className="modal-content">
        <div className="modal-header">
          {modalName}
          <div className="modal-close-btn" onClick={closeModal}>
            <IoIosCloseCircle />
          </div>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </Fragment>,
    document.getElementById("modal-container")
  );
};

export default Modal;
